/* eslint-disable react-hooks/exhaustive-deps */
import React, {  useEffect } from 'react'
import Banners from '../../Components/Banner/Banners'
import { useNavigate } from 'react-router-dom'
import SubscriptionSucess from '../../Components/Plans/SubscriptionSucess'

const Sucess = () => {
   

     const navigate = useNavigate();
    useEffect(()=>{
     if(!localStorage.getItem('token')) {
        navigate('/login')
     }
    },[])
    return (
        <>

            <Banners name="Subscription"/>
        
            <SubscriptionSucess/>


        </>
    )
}

export default Sucess